
import { createAction } from '../libs/redux/saga'
const baseURL = process.env.REACT_APP_URL
const baseREPO_URL = process.env.REACT_APP_REPO_URL
const baseAUTH_URL = process.env.REACT_APP_AUTH_URL

console.log("*****BASE", baseAUTH_URL)

export const ISLOGGED = "ISLOGGED";
export const FORGOT = "FORGOT";
export const LOGOUT = "LOGOUT";
export const LOGIN = "LOGIN";
//---------------------------------
export const DASHBOARD = "DASHBOARD";
export const ROLE = "ROLE";
export const ROLEALL = "ROLEALL";
export const USERROLE = "USERROLE";
export const USERROLEALL = "USERROLEALL";
export const PERMISSION = "PERMISSION";
export const SETTINGS = "SETTINGS";
export const USER = "USER";
export const USERALL = "USERALL";

export const CLIENT = "CLIENT";
export const CLIENTALL = "CLIENTALL";
export const SERVICE = "SERVICE";
export const SERVICEALL = "SERVICEALL";
export const CATEGORY = "CATEGORY";
export const CATEGORYALL = "CATEGORYALL";
export const TASK = "TASK";
export const TASKALL = "TASKALL";
export const UPCOMINGTASK = "UPCOMINGTASK";
export const WORK = "WORK";
export const WORKTASK = "WORKTASK";
export const WORKALL = "WORKALL";
export const WORKPROGRESS = "WORKPROGRESS";
export const WORKASSIGN = "WORKASSIGN";
export const WORKASSIGNALL = "WORKASSIGNALL";
export const INVOICE = "INVOICE";
export const INVOICEALL = "INVOICEALL";
export const NOTIFY = "NOTIFY";
export const CHAT = "CHAT";
export const CHATALL = "CHATALL";
export const TASKCHAT = "TASKCHAT";
export const TASKCHATALL = "TASKCHATALL";

export const REPO = "REPO";
export const REPOALL = "REPOALL";
export const COMMIT = "COMMIT";
export const COMMITALL = "COMMITALL";
export const PACKAGE = "PACKAGE";
export const PACKAGEALL = "PACKAGEALL";
export const HISTORYALL = "HISTORYALL";
export const COUNTRY = "COUNTRY";
export const STATE = "STATE";
export const CHATMESSAGE = "CHATMESSAGE";
export const CHATMESSAGEALL = "CHATMESSAGEALL";


export const ATTENDANCE = "ATTENDANCE";
export const ATTENDANCEALL = "ATTENDANCEALL";
export const LEAVE = "LEAVE";
export const LEAVEALL = "LEAVEALL";
export const WORKINGTIME = "WORKINGTIME";
export const WORKINGTIMEALL = "WORKINGTIMEALL";

export const REQUESTS = {
    ...createAction(LOGIN, "token", { loader: true }),
    ...createAction(LOGOUT, "token", {}),
    ...createAction(ISLOGGED, "token", {}),
    // ---  Do not update above code----
    ...createAction(DASHBOARD, "dashboard", {}),
    ...createAction(ROLE, "group", {}),
    ...createAction(ROLEALL, "group", {}),
    ...createAction(USERROLE, "user/group", {}),
    ...createAction(USERROLEALL, "user/group", {}),
    ...createAction(PERMISSION, "permission", {}),
    ...createAction(SETTINGS, "settings", {}),
    ...createAction(FORGOT, "public/forgotpassword", {}),
    ...createAction(USER, "user"),
    ...createAction(USERALL, "user"),

    ...createAction(CLIENT, "client", {}),
    ...createAction(CLIENTALL, "client", {}),
    ...createAction(SERVICE, "service", {}),
    ...createAction(SERVICEALL, "service", {}),
    ...createAction(CATEGORY, "category", {}),
    ...createAction(CATEGORYALL, "category", {}),
    ...createAction(ATTENDANCE, "attendance/logs", {}),
    ...createAction(ATTENDANCEALL, "attendance/logs", {}),
    ...createAction(LEAVE, "attendance/leave", {}),
    ...createAction(LEAVEALL, "attendance/leave", {}),
    ...createAction(WORKINGTIME, "attendance/settings", {}),
    ...createAction(WORKINGTIMEALL, "attendance/settings", {}),
    ...createAction(TASK, "task", {}),
    ...createAction(TASKALL, "task", {}),
    ...createAction(WORK, "work", {}),
    ...createAction(WORKTASK, "work-task", {}),
    ...createAction(WORKALL, "work", {}),
    ...createAction(WORKASSIGN, "work-assign", { loader: true }),
    ...createAction(WORKASSIGNALL, "work-assign", {}),
    ...createAction(INVOICE, "invoice", {}),
    ...createAction(INVOICEALL, "invoice", {}),
    ...createAction(CHAT, "work", {}),
    ...createAction(CHATALL, "work", {}),
    ...createAction(CHATMESSAGE, "chat", {}),
    ...createAction(CHATMESSAGEALL, "chat", {}),
    ...createAction(TASKCHAT, "task-chat", {}),
    ...createAction(TASKCHATALL, "task-chat", {}),
    ...createAction(UPCOMINGTASK, "upcoming/task"),
    ...createAction(COUNTRY, "countries"),
    ...createAction(STATE, "state"),

    ...createAction(REPO, "repo", { BASE_URL: baseREPO_URL }),
    ...createAction(REPOALL, "repo", { BASE_URL: baseREPO_URL }),
    ...createAction(PACKAGE, "package", { BASE_URL: baseREPO_URL }),
    ...createAction(PACKAGEALL, "package", { BASE_URL: baseREPO_URL }),
    ...createAction(COMMIT, "commit", { BASE_URL: baseREPO_URL }),
    ...createAction(COMMITALL, "commit", { BASE_URL: baseREPO_URL }),
    ...createAction(HISTORYALL, "file_history", { BASE_URL: baseREPO_URL }),


}
